import { render } from "./Vuniversity.vue?vue&type=template&id=c4ea8a6c&scoped=true"
import script from "./Vuniversity.vue?vue&type=script&lang=js"
export * from "./Vuniversity.vue?vue&type=script&lang=js"

import "./Vuniversity.vue?vue&type=style&index=0&id=c4ea8a6c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ea8a6c"]])

export default __exports__